<script>
import Dashboard from '@/plugins/dashboard'

export default {
  extends: Dashboard,
  widgets: [],
  data () {
    return {
      title: 'Dashboard',
      breadcrumb: {
        name: 'Dashboard',
        route: { name: 'sales-accounts-account-dashboard', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
